<template>
  <div class="pdp-bottom">
    <div class="pdp__bottom-mobile">
      <accordion heading="Features" activeIcon="chevron-down" inactiveIcon="chevron-up" selected v-if="features && features.length > 0">
        <div class="block__title">Features</div>
        <div class="feature__block-feature-list" :class="[ features.length == 1 ? 'full-width' : '']">
          <div class="feature__block-feature-item" v-for="(feature, index) in features" :key="index">
            {{ feature }}
          </div>
        </div>
      </accordion>

      <accordion heading="Includes" activeIcon="chevron-down" inactiveIcon="chevron-up" v-if="includes && includes.length > 0">
        <div class="block__title">Includes</div>
        <div class="includes__block-includes-container">
          <div class="includes_block-includes-intro-content" :class="[ includes.length == 1 ? 'full-width' : '']">
            <div class="includes_block-includes-intro-item" v-for="(intro, index) in includes" :key="index">
              {{ intro }}
            </div>
          </div>
          <div class="includes_block-includes-image" v-if="includes.Image">
            <img :src="includes.Image" alt="includes.Introduction" />
          </div>
        </div>
      </accordion>

      <accordion heading="Specifications" activeIcon="chevron-down" inactiveIcon="chevron-up" v-if="specs && specs.length > 0">
        <div class="block__title">Specifications</div>
        <div class="specs__block-spec-list" :style="{maxHeight: showAllSpec ? '484px' : 'none'}">
          <template v-for="(spec, index) in specs">
            <div class="specs__block-spec-item"  v-if="showSpecLabel(spec.name)" :key="index">
              <div class="specs__block-spec-key" v-html="getSpecLabel(spec.name)"></div>
              <div class="specs__block-spec-value"> {{ spec.value }} </div>
            </div>
          </template>
        </div>
        <template v-if="Object.keys(specs).length > 8">
          <div class="specs__block-gradient-layer"></div>
          <button class="specs__block-btn-view-all-specs" @click="showAllSpec = !showAllSpec">
            <span class="specs__block-plus-label">{{showAllSpec ? '+' : '-' }}</span>
            <span class="specs__block-btn-text">{{ showAllSpec ? "View All Specifications" : "Hide Specifications" }}</span>
          </button>
        </template>
      </accordion>

      <accordion heading="Additional Product Information" class="manual__block" activeIcon="chevron-down" inactiveIcon="chevron-up" v-if="manuals && Array.isArray(manuals.filename)">
        <div class="block__title">Additional Product Information</div>
        <!-- <div class="manual__block-manual-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan magna nisl ut pharetra. Eu cursus ultricies nisl in aenean a. Congue vulputate aliquet ac, duis ullamcorper non mattis et dolor. Eu tempor ut mi est, ac. </div> -->

         <div class="manual__block-manual-item test1" v-for="(manual, index) in manuals.source" :key="index">
          <div class="manual__block-manual-item-wrapper">
            <Icon name="file" size="16px"></Icon>
            <span class="manual_item-file-name" v-html="getManualsLabel(manual.original)"></span>
          </div>
          <a :href="getManualsLink(manual.original)" class="download-container" target="_blank">
            <span class="manual_item-download-link">Download</span>
            <Icon name="download" size="24px"></Icon>
          </a>
        </div> 
      </accordion>

      <accordion heading="Additional Product Information" class="manual__block" activeIcon="chevron-down" inactiveIcon="chevron-up" v-if="manuals && Array.isArray(manuals.filename) == false ">
        <div class="block__title">Additional Product Information</div>
        <!-- <div class="manual__block-manual-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan magna nisl ut pharetra. Eu cursus ultricies nisl in aenean a. Congue vulputate aliquet ac, duis ullamcorper non mattis et dolor. Eu tempor ut mi est, ac. </div> -->

        <div class="manual__block-manual-item test2">
          <div class="manual__block-manual-item-wrapper">
            <Icon name="file" size="16px"></Icon>
            <span class="manual_item-file-name" v-html="manuals.filename"></span>
          </div>
          <a :href="getManualsLink(manuals.source.original)" class="download-container" target="_blank">
            <span class="manual_item-download-link">Download</span>
            <Icon name="download" size="24px"></Icon>
          </a>
        </div> 
      </accordion>
    </div>

    <div class="pdp__bottom-desktop">
      <section id="section-features" class="feature__block" v-if="features && features.length > 0">
        <div class="block__title">Features</div>
        <div class="feature__block-feature-list" :class="[ features.length == 1 ? 'full-width' : '']">
          <div class="feature__block-feature-item" v-for="(feature, index) in features" :key="index">
            {{ feature }}
          </div>
        </div>
      </section>

      <section id="section-includes" class="includes__block" v-if="includes && includes.length > 0">
        <div class="block__title">Includes</div>
        <div class="includes__block-includes-container">
          <div class="includes_block-includes-intro-content" :class="[ includes.length == 1 ? 'full-width' : '']">
            <div class="includes_block-includes-intro-item" v-for="(intro, index) in includes" :key="index">
              {{ intro }}
            </div>
          </div>
          <div class="includes_block-includes-image" v-if="includes.Image">
            <img :src="includes.Image" alt="includes.Introduction" />
          </div>
        </div>
      </section>

      <section id="section-specs" class="specs__block" :class="[{'specs__block-collapse': !showAllSpec}, { 'specs__block-no__expandable': Object.keys(specs).length < 9 }]" v-if="specs && specs.length > 0">
        <div class="block__title">Specifications</div>
        <div class="specs__block-spec-list">
          <template v-for="(spec, index) in specs">
            <div class="specs__block-spec-item"  v-if="showSpecLabel(spec.name)" :key="`spec-${index}`">
              <div class="specs__block-spec-key" v-html="getSpecLabel(spec.name)"></div>
              <div class="specs__block-spec-value"> {{ spec.value }} </div>
            </div>
          </template>
        </div>
        <template v-if="Object.keys(specs).length > 8">
          <div class="specs__block-gradient-layer"></div>
          <button class="specs__block-btn-view-all-specs" @click="showAllSpec = !showAllSpec">
            <span class="specs__block-plus-label">{{showAllSpec ? '+' : '-' }}</span>
            <span class="specs__block-btn-text">{{ showAllSpec ? "View All Specifications" : "Hide Specifications" }}</span>
          </button>
        </template>
      </section>

      <section id="section-manuals" class="manual__block" v-if="manuals && Array.isArray(manuals.filename)">
        <div class="block__title">Additional Product Information</div>
        <!-- <div class="manual__block-manual-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan magna nisl ut pharetra. Eu cursus ultricies nisl in aenean a. Congue vulputate aliquet ac, duis ullamcorper non mattis et dolor. Eu tempor ut mi est, ac. </div> -->

       <div class="manual__block-manual-item test3" v-for="(manual, index) in manuals.source" :key="index">
          <div class="manual__block-manual-item-wrapper">
            <Icon name="file" size="20px"></Icon>
            <span class="manual_item-file-name" v-html="getManualsLabel(manual.original)"></span>
          </div>
          <a :href="getManualsLink(manual.original)" class="download-container" target="_blank">
            <span class="manual_item-download-link">Download</span>
            <Icon name="download" size="24px"></Icon>
          </a>
        </div>
      </section>

      <section id="section-manuals" class="manual__block" v-if="manuals && Array.isArray(manuals.filename) == false ">
        <div class="block__title">Additional Product Information</div>
        <!-- <div class="manual__block-manual-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan magna nisl ut pharetra. Eu cursus ultricies nisl in aenean a. Congue vulputate aliquet ac, duis ullamcorper non mattis et dolor. Eu tempor ut mi est, ac. </div> -->

       <div class="manual__block-manual-item test4">
          <div class="manual__block-manual-item-wrapper">
            <Icon name="file" size="20px"></Icon>
            <span class="manual_item-file-name" v-html="manuals.filename"></span>
          </div>
          <a :href="getManualsLink(manuals.source.original)" class="download-container" target="_blank">
            <span class="manual_item-download-link">Download</span>
            <Icon name="download" size="24px"></Icon>
          </a>
        </div>
      </section>

    </div>
    <section id="section-product-line" class="product-line__block" v-if="isChildProductsLoaded && childProducts.length > 1">
      <div class="block__title">Product Line</div>

      <div class="product-line__block-child__products">
        <button @click="childProductPrevious" v-if="childProducts.length > 1" class="product-line__prev-button" aria-label="Previous Product">
          <Icon class="product-line__button" name="chevron-left" size="44px"></Icon>
        </button>
        <flickity v-on:sendToPLModal="openSliderModal" ref="flickity" :options="flickityOptions" class="product-line__block-child__products-flickity">
          <template v-for="(product, index) in childProducts">
            <div v-if="index < 20" class="carousel-cell product-line__block-child_products-carousel-cell" :key="index">
              <ProductCard 
                :inSlider="true" 
                v-on:sliderQuickview="sendDataToPLModal" 
                :placeholder="placeholder" :data="JSON.stringify({product})" 
                :quickviewData="JSON.stringify({product})" />
            </div>
          </template>
        </flickity>
        <button @click="childProductNext" v-if="childProducts.length > 1" class="product-line__next-button" aria-label="Next Product">
          <Icon class="product-line__button" name="chevron-right" size="44px"></Icon>
        </button>
      </div>

      <Modal class="quickview-modal" ref="sliderQuickview" :useTransition="false">
        <template slot="content">
          <ProductTop v-on:addToCart="closeModal" class="pdp-top--quickview" :data="sliderQuickviewData" :isQuickview="true"></ProductTop>
        </template>
      </Modal>

    </section>
  </div>
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import ProductCard from "./ProductCard.vue"
  import Modal from 'scripts/components/basic/Modal.vue';
  import ProductTop from 'scripts/components/product/ProductTop.vue';
  import Flickity from 'vue-flickity';
  import Accordion from '../basic/Accordion.vue';

  export default {
    name: "ProductBottom",
    props: {
      product: Object,
      quickview: Object,
      placeholder: Object,
      specsdata: Object,
    },
    components: { Icon, ProductCard, Flickity, Accordion, Modal, ProductTop },
    data() {
      return {
        showAllSpec: true,
        childProducts: [],
        specData: null,
        specList: [],
        isChildProductsLoaded: false,
        sliderQuickviewData: '',
        BVAGlobal: window.__BVA__,
      }
    },
    computed: {
      customData() {
        const { description } = this.BVAGlobal.currentVariant.description
        if (this.BVAGlobal.currentVariant.description) {
          return JSON.parse(this.BVAGlobal.currentVariant.description)
        }
        return null
      },
      features() {
        if (this.customData) {
          const { featuresandbenefits } = this.customData
          if (featuresandbenefits) {
            return featuresandbenefits.split("|")
          }
        }
        return []
      },
      specs() {
        if (this.customData) {
          const { specs } = this.customData
          if (specs && specs.spec) {
            let filteredSpecs = [];
            for (let i = 0; i < specs.spec.length; i++) {
              if (specs.spec[i].name.includes('_Specs')) {
                filteredSpecs.push(specs.spec[i]);
              }
            }
            return filteredSpecs;
          }
        }
        return []
      },
      includes() {
        if (this.customData) {
          const { contents } = this.customData
          if (contents) {
            return contents.split("|")
          }
        }
        return []
      },
      manuals() {
        if (this.customData) {
          const { drawings } = this.customData
          return drawings
        }
        return null
      },
      childproductIDs() {
        if (this.customData) {
          const { childproducts } = this.customData
          if (childproducts && childproducts.childproduct) {
            return childproducts.childproduct
          }
        }

        return []
      },
      flickityOptions() {
        return {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: this.childProducts.length > 4 ? true : false,
          cellAlign: 'left'
        }
      }
    },
    mounted() {
      if (this.childproductIDs.length > 0) {
        this.getChildProducts()
      }
    },
    methods: {
      openSliderModal(data) {
        this.sliderQuickviewData = data;
        this.$refs.sliderQuickview.open();
      },
      closeModal() {
        this.$refs.sliderQuickview.close();
      },
      sendDataToPLModal(data) {
        this.sliderQuickviewData = data;
        this.$refs.sliderQuickview.open();
        // this.$emit('sendToPLModal', data);
      },
      getChildProducts() {
        let resCount = 0
        this.childproductIDs.forEach(productId => {
          let fetchURL = '/search?type=product&q=variants.sku:' + productId + '&view=sku';
            fetch(fetchURL)
              .then((response) => response.json())
              .then((prodData) => {
                if (prodData.products.length > 0) {
                  this.childProducts.push(prodData.products[0])
                }
              })
              .then(() => {
                if (++resCount == this.childproductIDs.length) {
                  this.isChildProductsLoaded = true
                }
              })
        })
      },
      childProductNext() {
        let currentSlide = this.$refs.flickity.$flickity.selectedIndex + 1;
        if (currentSlide > (this.$refs.flickity.$flickity.slides.length - 1)) {
          this.$refs.flickity.selectCell(0);
        } else {
          this.$refs.flickity.selectCell(currentSlide);
        }
      },
      childProductPrevious() {
        let currentSlide = this.$refs.flickity.$flickity.selectedIndex - 1;
        if (currentSlide < 0) {
          let totalSlides = this.$refs.flickity.$flickity.slides.length - 1;
          this.$refs.flickity.selectCell(totalSlides);
        } else {
          this.$refs.flickity.selectCell(currentSlide);
        }
      },
      getSpecLabel(specVariable) {
        if(this.specsdata[specVariable]) {
          return this.specsdata[specVariable];
        }
        return ''
      },
      getManualsLabel(manualsVariable) {
        let mamnualsFilename = manualsVariable;
        mamnualsFilename = mamnualsFilename.replace("Drawings/Mac/", "");
        mamnualsFilename = mamnualsFilename.split("/")[1];
        return mamnualsFilename;
      },
       getManualsLink(manualsLink) {
        let manualsDownload = manualsLink;
        manualsDownload = manualsDownload.replace("Drawings/Mac/", "");
        manualsDownload = manualsDownload.replace(".PDF",".pdf");
        manualsDownload = "https://sbdcdn.sbd-prod.com/ASSETS/MACTOOLS/NA/PRODUCT/DOCUMENTS/"+manualsDownload;
        return manualsDownload;
      },
      showSpecLabel(specVariable) {
        if(this.specsdata[specVariable]) {
          return true;
        }
        return false;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
